import { Create, SimpleForm, type CreateProps } from "react-admin";

import MiqaatVenueFormFields from "./MiqaatVenueFormFields";
import { transformMiqaatVenuePayload } from "./transform-miqaat-venue-payload";

export default function MiqaatVenueCreate(props: CreateProps) {
  return (
    <Create {...props} redirect="list" transform={transformMiqaatVenuePayload}>
      <SimpleForm warnWhenUnsavedChanges sx={{ maxWidth: 720 }}>
        <MiqaatVenueFormFields isCreate />
      </SimpleForm>
    </Create>
  );
}
